import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SearchHistoryAction } from "stores/SearchHistory/SearchHistoryAction";
// import { bookingTableActions } from "stores/BookingTableStore/bookingTableAction";
// import { commonActions } from "stores/common/commonActions";
const mapStateToProps = (state) => {
    
  return {
  
    SearchHistoryDataList: state.SearchHistoryData.SearchHistoryDataList,
    isLoading:state.SearchHistoryData.SearchHistoryDataloading.isLoading
  
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

SearchHistoryAction: SearchHistoryAction.getSearchHistoryData,
}, dispatch);

const SearchHistoryStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default SearchHistoryStore;
 